import React, { useContext, useMemo } from 'react';
import { Box } from '@mui/material';
import { observer } from 'mobx-react';

import CoachesListContext from '../../../context/CoachesListContext';
import { LeadCampaignSource } from '../../../../Model/MassTextCampaign';

import { useCampaignCollection } from '../hooks/useCampaignCollection';
import { EM_DASH } from '../utils/constants';
import texts from '../texts.json';

import CampaignTable from '../components/CampaignTable';
import metricColumns, { nameColumn, coachColumn } from '../components/campaignColumns';

const HistoryTab = () => {
  const {
    docs,
    userNames,
    loading,
    error,
  } = useCampaignCollection({ source: LeadCampaignSource.MANUAL, resolveSenders: true });
  const { coachesList, isReady: coachesReady } = useContext(CoachesListContext);

  const columns = useMemo(() => [
    nameColumn(texts.history.columns),
    coachColumn(texts.history.columns, coachesList),
    {
      field: 'sentByName',
      headerName: texts.history.columns.sentBy,
      flex: 1,
      valueGetter: ({ row }) => userNames[row.createdBy] || EM_DASH,
    },
    ...metricColumns(texts.history.columns),
  ], [coachesList, userNames]);

  return (
    <Box sx={{ p: 3 }}>
      <CampaignTable
        docs={docs}
        columns={columns}
        loading={loading || !coachesReady}
        error={error}
        coachesList={coachesList}
        userNames={userNames}
        noticeText={texts.history.syncNotice}
        emptyText={texts.history.empty}
        errorText={texts.history.error}
      />
    </Box>
  );
};

export default observer(HistoryTab);
